import {store} from "../redux/store";
import {GeneralService} from "../services/GeneralService";
import {jwtDecode} from "jwt-decode";
import {updateUserData} from "../redux/slices/authSlice";

const getNewTokenAndPermissions = async () => {
    const refreshToken = store.getState().auth?.refreshToken;
    const user = store.getState().auth?.user;

    const res = await GeneralService.getNewAccessToken(refreshToken);
    const decoded = jwtDecode(res?.accessToken);
    // It returns as a string if it has a single value, and we need it always as an array.
    const permissions = Array.isArray(decoded?.Permissions) ? decoded?.Permissions : [decoded?.Permissions]

    store.dispatch(
        updateUserData({
            isLoggedIn: true,
            token: res?.accessToken,
            refreshToken: res?.refreshToken,
            user: {
                ...user,
                permissions,

                selectedTenant: {
                    ...user.selectedTenant,
                    permissions
                }
            },
        })
    );

    return res
}

export default getNewTokenAndPermissions;